import { FB_DELETE_CONTENT_TIMEOUT } from '$extensionSrc/consts/stageMachineConsts'
import { FacebookSettingKey } from '$extensionSrc/recommendations/recommendationSettingsKeys'
import { StageType, FBRecommendationKey } from '$extensionSrc/utils/enums'

import { StageDef } from '../automationMachineInterfaces'
import {
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
} from '../recommendationCardDisplayUtils'
import { FACEBOOK_AUTOMATION_STAGE_STATUSES } from './facebookAutomationStageStatuses'
import {
  getFacebookDeleteBeginUpdateStageAction,
  getFacebookDeleteCleanupAction,
  getFacebookDeleteContentCategoryForMonthStageAction,
  getFacebookDeleteContentFinishStageAction,
  getFacebookLoadDeleteContentCategoryStageAction,
  getFacebookLoadOldestPostStageAction,
  getFacebookSaveOldestPostStageAction,
} from './fbContentUtils'
import { FacebookContentCategoryKey } from './fbUrls'

const getCurrentValueFn = () => () => ''

const getIsFulfilledFn = () => () => false
const settingsToContentType = {
  [FacebookSettingKey.DELETE_PAGE_LIKES]: FacebookContentCategoryKey.PAGES,
}

const deletePostLabels = {
  [FacebookSettingKey.DELETE_PAGE_LIKES]: ['remove'],
}

const deletePostModalTitles = {
  [FacebookSettingKey.DELETE_PAGE_LIKES]: 'remove interaction?',
}

const confirmDeleteLabels = {
  [FacebookSettingKey.DELETE_PAGE_LIKES]: 'remove',
}

const deletePostPageTitles = {
  [FacebookSettingKey.DELETE_PAGE_LIKES]: 'pages, page likes and interests',
}

const postTypes = {
  [FacebookSettingKey.DELETE_PAGE_LIKES]: 'page likes and interests',
}

// Tasks require initial values in a single setting key
const initialValuesSettingKey = FacebookSettingKey.DELETE_PAGE_LIKES
const contentType = 'page likes and interests'
const mainPageCategory = FacebookContentCategoryKey.PAGES
const mainPageTitle = 'pages, page likes and interests'

const gatherStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: `GATHER_DELETE_PAGE_LIKES_LOAD_ACTIVITY_LOG`,
    status: FACEBOOK_AUTOMATION_STAGE_STATUSES.FB_DELETE_START,
    action: getFacebookLoadOldestPostStageAction(),
  },
  {
    type: StageType.ACTION,
    key: `GATHER_DELETE_PAGE_LIKES_GET_OLDEST_ACTIVITY`,
    status: FACEBOOK_AUTOMATION_STAGE_STATUSES.FB_DELETE_START,
    action: getFacebookSaveOldestPostStageAction(
      initialValuesSettingKey,
      FBRecommendationKey.FB_DELETE_PAGE_LIKES,
    ),
  },
  {
    type: StageType.ACTION,
    key: `GATHER_DELETE_PAGE_LIKES_CLEANUP`,
    status: FACEBOOK_AUTOMATION_STAGE_STATUSES.FB_DELETE_END,
    action: getFacebookDeleteCleanupAction(
      FacebookContentCategoryKey.PAGES,
      mainPageTitle,
    ),
  },
]

const getCantUndoFn = () => () => true

const getIsDisabledFn = () => defaultIsDisabledFn

const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

const updateStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: `UPDATE_DELETE_PAGE_LIKES_LOAD_ACTIVITY_LOG`,
    status: FACEBOOK_AUTOMATION_STAGE_STATUSES.FB_DELETE_START,
    action: getFacebookDeleteBeginUpdateStageAction(
      FBRecommendationKey.FB_DELETE_PAGE_LIKES,
    ),
  },
  {
    type: StageType.ACTION,
    key: `UPDATE_DELETE_PAGE_LIKES_GET_OLDEST_ACTIVITY`,
    status: FACEBOOK_AUTOMATION_STAGE_STATUSES.FB_DELETE_START,
    action: getFacebookSaveOldestPostStageAction(
      initialValuesSettingKey,
      FBRecommendationKey.FB_DELETE_PAGE_LIKES,
    ),
  },
  // Create flat array by adding each stage definition directly
  ...Object.keys(settingsToContentType).flatMap((s: FacebookSettingKey) => [
    {
      type: StageType.ACTION,
      key: `UPDATE_LOAD_${s}`,
      timeout: FB_DELETE_CONTENT_TIMEOUT,
      action: getFacebookLoadDeleteContentCategoryStageAction(
        initialValuesSettingKey,
        settingsToContentType[s],
      ),
    },
    {
      type: StageType.ACTION,
      key: `UPDATE_MONTH_${s}`,
      timeout: FB_DELETE_CONTENT_TIMEOUT,
      action: getFacebookDeleteContentCategoryForMonthStageAction(
        settingsToContentType[s],
        s,
        FBRecommendationKey.FB_DELETE_PAGE_LIKES,
        postTypes[s],
        deletePostPageTitles[s],
        deletePostLabels[s],
        deletePostModalTitles[s],
        confirmDeleteLabels[s],
        contentType,
        initialValuesSettingKey,
      ),
    },
  ]),
  {
    type: StageType.ACTION,
    key: `UPDATE_DELETE_PAGE_LIKES_FINISH`,
    status: FACEBOOK_AUTOMATION_STAGE_STATUSES.FB_DELETE_END,
    action: getFacebookDeleteContentFinishStageAction(
      FBRecommendationKey.FB_DELETE_PAGE_LIKES,
      initialValuesSettingKey,
      contentType,
      mainPageCategory,
      mainPageTitle,
    ),
  },
]

const undoStageDefs: StageDef[] = []

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
